import React from "react";
import { useFormContext } from "react-hook-form";
import { IAddProductInput, IAttribute, AttributeType } from "muminsmart-utils";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface ProductAttributeFieldProps {
  attribute: IAttribute;
  variantIndex: number;
  attributeIndex: number;
}

const ProductAttributeField: React.FC<ProductAttributeFieldProps> = ({
  attribute,
  variantIndex,
  attributeIndex,
}) => {
  const form = useFormContext<IAddProductInput>();

  return (
    <FormField
      control={form.control}
      name={`variants.${variantIndex}.variantAttributes.${attributeIndex}.value`}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{attribute.name}</FormLabel>
          <FormControl>
            {attribute.type === AttributeType.SELECT ? (
              <Select value={field.value} onValueChange={field.onChange}>
                <SelectTrigger className="w-full rounded-full p-5 border-muted bg-white text-[0.9rem]">
                  <SelectValue placeholder={`Select ${attribute.name}`} />
                </SelectTrigger>
                <SelectContent>
                  {(attribute.attributeDetails ?? []).map((detail) => (
                    <SelectItem key={detail.id} value={detail.value}>
                      {detail.value}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            ) : attribute.type === AttributeType.CHECKBOX ? (
              <div className="flex items-center gap-2 h-9">
                <Input
                  type="checkbox"
                  id={`${variantIndex}-${attribute.id}-${attributeIndex}`}
                  checked={field.value === "true"}
                  onChange={(e) =>
                    field.onChange(e.target.checked ? "true" : "false")
                  }
                  className="h-4 w-4 cursor-pointer accent-amber-600"
                />
                <label
                  htmlFor={`${variantIndex}-${attribute.id}-${attributeIndex}`}
                  className="text-sm text-muted-foreground cursor-pointer select-none"
                >
                  {attribute.name}
                </label>
              </div>
            ) : (
              <Input
                {...field}
                className="rounded-3xl p-3 border-muted bg-white"
                id={`${variantIndex}-${attribute.id}-${attributeIndex}`}
                type={
                  attribute.type === AttributeType.NUMBER ? "number" : "text"
                }
                placeholder={`Enter ${attribute.name}`}
                onChange={(e) => {
                  // if (attribute.type === AttributeType.NUMBER) {
                  //   field.onChange(parseInt(e.target.value));
                  // } else {
                  // }
                  field.onChange(e.target.value);
                }}
              />
            )}
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default ProductAttributeField;
